import { useState, useEffect } from 'react'

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false
  
  // Primarily check for mobile user agents, with width as secondary check
  const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const isSmallScreen = window.innerWidth <= 768
  
  // True mobile devices OR very small screens (likely mobile)
  return isMobileUserAgent || (isSmallScreen && window.innerWidth <= 480)
}

export function useMobile() {
  const [isMobile, setIsMobile] = useState(false)
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileDevice())
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    
    return () => window.removeEventListener('resize', checkMobile)
  }, [])
  
  return isMobile
} 